// extracted by mini-css-extract-plugin
export default {"Loading":"LoadingMessages_Loading__Du+2B","LoadingTextContainer":"LoadingMessages_LoadingTextContainer__WXYQl","LoadingText":"LoadingMessages_LoadingText__Q8x80"};